import _ from 'underscore';
import {XmlTagInfo} from './xmlTagProvider';
import Messages from './messages'

/*
    XML EXAMPLE

    <options>
        <list id="27_cmb1">
            <item value="1">volba</item>
            <item value="2" textbox="yes" inputTextText=", vypište:">jiný</item>
        </list>
        <list id="43_cmb1">
            <item value="1">one</item>
            <item value="2">two</item>
            <item value="3">three</item>
        </list>
        <list id="43_cmb2">
            <item value="1">a</item>
            <item value="2">b</item>
        </list>
    </options>
 */


export interface OptionItem {
    name: string;
    value?: string;
    hasInputText: boolean;
    inputTextText?: string;
}

export class Options {

    private messages?: Messages;
    private translatablePlaceholders: any[] = [];

    static fromXML(node: XmlTagInfo, messages: Messages){

        let translatablePlaceholder = null;
        const translatablePlaceholders: any[] = [];

        const lists = _.map(node.children, listTag => {

            const childrenByTag = _.groupBy(listTag.children, 'tag');
            const items: OptionItem[] = _.map(<XmlTagInfo[]>childrenByTag['item'], o => {
                return {
                    name: o.value === undefined ? '' : o.value, // <item>this is value</item> should be always set in XML ()
                    value: o.attributes['value'], //<item value="that value" />
                    hasInputText: o.attributes['inputText'] === 'yes',
                    inputTextText: o.attributes['inputTextText'],
                }
            });

            const placeholders = <XmlTagInfo[]>childrenByTag['placeholder'];
            translatablePlaceholder = {
                name: (placeholders ? placeholders[0].value! : messages.get("comboPlaceholder")), // setup placeholder, fallback to default from messages
                value: undefined,
                hasInputText: false,
                inputTextText: undefined,
            };
            items.unshift(translatablePlaceholder);

            if (!placeholders) {
                translatablePlaceholders.push(translatablePlaceholder);
            }

            return [listTag.attributes['id'], items];
        });

        const options = new Options(<{[id: string] : OptionItem []}>_.object(lists));
        options.messages = messages;
        options.translatablePlaceholders = translatablePlaceholders;

        return options;
    }

    constructor(
        private optionsById: {[id: string] : OptionItem []}
    ){}

    getList(id: string){
        return this.optionsById[id]
    }

    onLangChange() {
        for (let i in this.translatablePlaceholders) {
            this.translatablePlaceholders[i].name = this.messages!.get("comboPlaceholder");
        }
    }
}